import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'firstWord'
})
export class FirstWordPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) { return ''; }

    const words = value.split(' ');

    if (words[0].length < 4 && words.length > 1) {
      return `${words[0]} ${words[1]}`;
    }

    return words[0];
  }

}
